export default "__VITE_ASSET__Dvi7xIU___"